import { Api } from '@/api/Api'
import _ from 'lodash'
import { ActionTree } from 'vuex'
import { ResponseArray, RootState } from '../types'
import { blankUserArray } from './constants'
import State, { IUser, IUserSearchFilter } from './types'
import { HttpMethod } from '@/api/FetchApi'
import SecurityState from '../security/types'
const api = new Api()

export const actions: ActionTree<State, RootState> = {
  getCurrentUserProfile({ commit }): any {
    commit('userLoading')
    const url = '/user/me/profile'
    const securityState = (this.state as any).security as SecurityState
    return api
      .fetchV2({
        url,
        user: securityState.currentUser,
      })
      .then((response) => {
        if (!response.Successful) {
          commit('userError', response.Message ?? 'Error loading user')
          return null
        }

        commit('userLoaded', response)
        return response
      })
      .catch(({ message }: { message: string | undefined }) => {
        commit('userError', message ?? 'Error loading user')
      })
  },
  requestPermissionsForUser(x, permissionsRequest: { salesRepIds: [], customerNumbers: [] }): any {
    const url = '/user/me/permissions-request'
    const securityState = (this.state as any).security as SecurityState
    return api
      .fetchV2({
        url,
        obj: permissionsRequest,
        method: HttpMethod.Post,
        user: securityState.currentUser,
      })
      .then((response) => {
        if (!response.Successful) {
          throw response
        }

        return response
      })
  },
  addPermissionsForUser(x, permissionsRequest: { salesRepIds: [], customerNumbers: [], userId: number }): any {
    const url = '/user/me/add-permissions'
    const securityState = (this.state as any).security as SecurityState
    return api
      .fetchV2({
        url,
        obj: permissionsRequest,
        method: HttpMethod.Post,
        user: securityState.currentUser,
      })
      .then((response) => {
        if (!response.Successful) {
          throw response
        }

        return response
      })
  },
  getUserById({ commit }, id: string): any {
    commit('userLoading')
    if (id.indexOf('%5C') >= 0) { // IIS does not like '\' so we have to double encode it.
      id = encodeURIComponent(id)
    }
    const url = `/user/${id}/`
    const securityState = (this.state as any).security as SecurityState
    return api
      .fetchV2({
        url,
        user: securityState.currentUser,
      })
      .then((response) => {
        if (!response.Successful) {
          commit('userError', response.Message ?? 'Error loading user')
          return null
        }

        commit('userLoaded', response)
        return response
      })
      .catch(({ message }: { message: string | undefined }) => {
        commit('userError', message ?? 'Error loading user')
      })
  },
  getUsers(
    { commit },
    searchFilters: IUserSearchFilter,
  ) {
    const {
      page,
      sortBy,
      sortDesc,
      userName = '',
      firstName = '',
      lastName = '',
      salesRepNumber = '',
      customerNumber = '',
      pageSize = 10,
    } = searchFilters
    commit('usersLoading')
    const url =
      '/user?PageSize=' +
      pageSize +
      '&Page=' +
      page +
      '&SortBy=' +
      sortBy +
      '&SortDirection=' +
      (sortDesc ? 'desc' : 'asc') +
      '&userName=' +
      encodeURIComponent(userName ?? '') +
      '&firstName=' +
      encodeURIComponent(firstName ?? '') +
      '&lastName=' +
      encodeURIComponent(lastName ?? '') +
      '&salesRepNumber=' +
      encodeURIComponent(salesRepNumber ?? '') +
      '&customerNumber=' +
      encodeURIComponent(customerNumber ?? '')
    const securityState = (this.state as any).security as SecurityState
    return api
      .fetchV2({
        url,
        user: securityState.currentUser,
      })
      .then((response) => {
        const users: ResponseArray<IUser> = _.assign({}, blankUserArray)
        users.loading = false
        users.List = response.List
        users.Page = response.Page
        users.PageSize = response.PageSize
        users.Total = response.Total

        commit('usersLoaded', users)
        commit('userFilterUpdated', searchFilters)
        return users
      })
      .catch(({ message }: { message: string | undefined }) => {
        commit('userError', message ?? 'Error loading user')
        commit('userFilterError')
      })
  },

  getSalesRepListByNumber(x, { salesRepIds }: { salesRepIds: string[] }): any {
    const url = '/user/salesreplist'
    const obj = salesRepIds
    const securityState = (this.state as any).security as SecurityState
    return api.fetchV2({
      url,
      obj,
      method: HttpMethod.Post,
      user: securityState.currentUser,
    })
      .then((response) => {
        if (!response.Successful) {
          throw response
        }
        return response
      })
  },

  getUserSalesRep(): any {
    const url = '/user/user_salesreps'
    const securityState = (this.state as any).security as SecurityState
    return api.fetchV2({
      url,
      method: HttpMethod.Post,
      user: securityState.currentUser,
    })
      .then((response) => {
        if (!response.Successful) {
          throw response
        }
        return response
      })
  },

  getCustomerListByNumber(x, { customerIds }: { customerIds: string[] }): any {
    const url = '/user/customerlist'
    const obj = customerIds
    const securityState = (this.state as any).security as SecurityState
    return api.fetchV2({
      url,
      obj,
      method: HttpMethod.Post,
      user: securityState.currentUser,
    })
      .then((response) => {
        if (!response.Successful) {
          throw response
        }
        return response
      })
  },

  saveUserProfile(x, { user }: { user: any }): any {
    const securityState = (this.state as any).security as SecurityState
    return api.fetchV2({
      url: `/user/updateprofile/${user.UserId}`,
      obj: { Email: user.Email, Name: user.Name, LastName: user.LastName },
      method: HttpMethod.Post,
      user: securityState.currentUser,
    }).then(response => {
      if (!response.Successful) {
        throw response
      }
      return response
    })
  },
}
